import { Tag as TagType } from "../../types";

export function convertToAntTag(tags) {
  return (
    tags !== null &&
    tags?.map((tag: TagType) => ({
      label: tag?.name,
      value: tag?.color,
      key: tag?.name,
    }))
  );
}
